const File = {

    init(form) {
        this.el = form.find('.input.file');
        if (!this.el.length) return;

        this.input = this.el.find('input[type="file"]');
        this.label = this.el.find('label');
        this.caption = this.el.find('.filename span');
        this.button = this.el.find('button');
        this.bind();
    },

    bind() {

        this.button.click((evt) => {
            this.input.click();
        })

        this.input.change((evt)=>{
            const fileName = evt.target.value.split("\\").pop();
            this.caption.text(fileName);
            $(evt.target).parent().addClass('filled');
        })
    },
}

export default File;